// extracted by mini-css-extract-plugin
export default {"container":"Collapse_container__Jl3lP","stile":"Collapse_stile__ErXZu","bodyCon":"Collapse_bodyCon__Oc5fe","perso":"Collapse_perso__EwyGG","butoon":"Collapse_butoon__LK8mO"};